import {
  ButtonStandard,
  ButtonGroupCode,
  SmallButtons,
  LargeButtons,
  ButtonsOutlined,
  ButtonCollection,
  CloseButtonCode,
  LinkButtonCode,
} from './codeHighlights/ButtonCode';

const Buttons = () => {
  return (
    <>
      <h1>Buttons</h1>

      <h2>Standard Buttons</h2>
      <div className="my-5">
        <a className="btn btn-primary" href="#">
          A-Tag Button
        </a>
        <button className="btn btn-secondary mx-3">A-Tag Button</button>
        <button className="btn btn-light" type="reset">
          Reset Button
        </button>
      </div>

      <ButtonStandard />

      <h2 className="mt-5">Button Group</h2>
      <div className="my-5">
        <div className="btn-group" role="group" aria-label="Basic example">
          <button type="button" className="btn btn-secondary">
            Left
          </button>
          <button type="button" className="btn btn-secondary">
            Middle
          </button>
          <button type="button" className="btn btn-secondary">
            Right
          </button>
        </div>
      </div>

      <ButtonGroupCode />

      <h2 className="mt-5">Outlined Buttons</h2>
      <div className="my-5">
        <button type="button" className="btn btn-outline-primary">
          Primary
        </button>
        <button type="button" className="btn btn-outline-secondary">
          Secondary
        </button>
        <button type="button" className="btn btn-outline-success">
          Success
        </button>
        <button type="button" className="btn btn-outline-danger">
          Danger
        </button>
        <button type="button" className="btn btn-outline-warning">
          Warning
        </button>
        <button type="button" className="btn btn-outline-info">
          Info
        </button>
        <button type="button" className="btn btn-outline-light">
          Light
        </button>
        <button type="button" className="btn btn-outline-dark">
          Dark
        </button>
      </div>

      <ButtonsOutlined />

      <h2 className="mt-5">Small Buttons</h2>
      <div className="my-5">
        <a className="btn btn-primary btn-sm" href="#">
          A-Tag Button Small
        </a>
        <a className="btn btn-secondary btn-sm" href="#">
          A-Tag Button Small
        </a>
      </div>

      <SmallButtons />

      <h2 className="mt-5 ">Large Buttons</h2>
      <div className="my-5">
        <a className="btn btn-primary btn-lg" href="#">
          A-Tag Button Large
        </a>
        <a className="btn btn-secondary btn-lg" href="#">
          A-Tag Button Large
        </a>
      </div>

      <LargeButtons />

      <h2 className="mt-5">Disabled Buttons</h2>
      <div className="my-5">
        <button type="button" className="btn btn-primary" disabled>
          Primary button
        </button>
        <button type="button" className="btn btn-secondary" disabled>
          Button
        </button>
      </div>

      <h2>Button Collection</h2>
      <div className="my-5">
        <button type="button" className="btn btn-primary">
          Primary
        </button>
        <button type="button" className="btn btn-secondary">
          Secondary
        </button>
        <button type="button" className="btn btn-success">
          Success
        </button>
        <button type="button" className="btn btn-danger">
          Danger
        </button>
        <button type="button" className="btn btn-warning">
          Warning
        </button>
        <button type="button" className="btn btn-info">
          Info
        </button>
        <button type="button" className="btn btn-light">
          Light
        </button>
      </div>

      <ButtonCollection />

      <h2 className="mt-5">Link Button</h2>
      <a className="btn btn-primary" href="#" role="button">
        Link
      </a>

      <div className="mt-5">
        <LinkButtonCode />
      </div>

      <h2 className="mt-5">Close Button</h2>
      <button type="button" className="btn-close" aria-label="Close" />

      <div className="mt-5">
        <CloseButtonCode />
      </div>
    </>
  );
};

export default Buttons;
